import React from 'react';

export default function ConfirmationHotelRow({ orderRow, breakouts, displayConfirmationSettings, environment, mainEvent }) {
  const { amount, vatAmount, hotelName, roomType, rowTotal, nights, rooms, roomSize, vatPercent, startDateTime, endDateTime } = orderRow;
  return (
    <>
      <tr className="cms-table-row whitespace-nowrap">
        {displayConfirmationSettings['ShowHotelName'] && (
          <td className="cms-table-cell max-w-[400px] text-ellipsis overflow-x-hidden">
            <span>{hotelName}</span>
          </td>
        )}
        {displayConfirmationSettings['ShowRoomType'] && (
          <td className="cms-table-cell max-w-[120px] text-ellipsis overflow-x-hidden">
            <span>{roomType}</span>
          </td>
        )}
        {displayConfirmationSettings['ShowSize'] && <td className="cms-table-cell text-right">{roomSize}</td>}
        {displayConfirmationSettings['ShowOccupants'] && <td className="cms-table-cell text-left">{rooms?.map(({ roomMate }) => roomMate)?.join(', ')}</td>}
        {displayConfirmationSettings['ShowNights'] && <td className="cms-table-cell text-right">{nights}</td>}
        {displayConfirmationSettings['ShowCheckin'] && <td className="cms-table-cell">{startDateTime}</td>}
        {displayConfirmationSettings['ShowCheckout'] && <td className="cms-table-cell">{endDateTime}</td>}

        {displayConfirmationSettings['ShowPriceExVat'] && (
          <td className="cms-table-cell text-right">
            {Math.round(amount)} {` ${environment.currency}`}
          </td>
        )}

        {displayConfirmationSettings['ShowVatAmount'] && (
          <td className="cms-table-cell text-right">
            {Math.round(vatAmount)} {` ${environment.currency}`}
          </td>
        )}
        {displayConfirmationSettings['ShowVatPercent'] && (
          <td className="cms-table-cell text-right">
            {vatPercent}
            {`%`}
          </td>
        )}
        {displayConfirmationSettings['ShowPriceTotal'] && (
          <td className="cms-table-cell text-right">
            {Math.round(rowTotal)} {` ${environment.currency}`}
          </td>
        )}
      </tr>
    </>
  );
}
